import React, { useState } from 'react';
import ReactModal from 'react-modal';
import * as MDICONS from '@material-ui/icons';
import { Link } from "react-router-dom";
import * as ROUTES from '../../constants/routes';
import styled from 'styled-components';
import { connect } from 'react-redux';
import CreateCompanyModal from './CreateCompanyModal';

const CreateButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;
const JoinProjectButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;
const CreateCompanyButton = (props) => {
    const [controlModal, setControlModal] = useState({ toggle: false });

    const {
        modalStyles,
        commons,
    } = props;

    return (
        <React.Fragment>
            {/* CONTROL MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={controlModal.toggle}
                onRequestClose={() => { setControlModal({ toggle: false }) }}
                contentLabel="See controls"
                ariaHideApp={false}
            >
                <button className="close" onClick={() => { setControlModal({ toggle: false }) }}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <CreateCompanyModal />
            </ReactModal>

            {/* COMPONENT MAIN */}
            <div className="row">
                <CreateButton themeColors={props.themeColors}>
                    <button className="btn btn-default btn-md" style={{ borderRadius: '10px', marginLeft: '15px' }} onClick={() => { setControlModal({ toggle: true }) }}>
                        <MDICONS.Add /> Create new company
                    </button>
                </CreateButton>
                <Link to={ROUTES.HOME_JOIN_PROJECT}>
                    <JoinProjectButton themeColors={props.themeColors}>
                        <button className="btn btn-default btn-md" style={{ borderRadius: '15px' }}>
                            <MDICONS.GroupAdd /> Join a {commons.project}
                        </button>
                    </JoinProjectButton>
                </Link>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    // console.log(state)
    return {
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        commons: state.commons,
    }
}

export default connect(mapStateToProps)(CreateCompanyButton);